import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";

export default {
    namespaced: true,
    state: () => ({
        currentPeriod: 'day', // day, week, month
        startDate: null,
        endDate: null,
        events: [],
        isPending: false,
        cancellationTokenSorce: null

    }),
    mutations: {
        SET_CURRENT_PERIOD (state, payload) {
            state.currentPeriod = payload;
        },
        SET_START_DATE(state, payload){
            state.startDate = payload;
        },
        SET_END_DATE(state, payload){
            state.endDate = payload;
        },
        SET_EVENTS(state, payload){
            state.events = payload;
        },
        IS_PENDING(state, payload){
            state.isPending = payload;
        },
    },
    actions: {
        getFilterObject({state}) {
            let filter = {
                FromDate: state.startDate,
                ToDate: state.endDate
            }
           return JSON.stringify(filter);
        },
        async updateEvents({ dispatch, commit }) {
            commit('IS_PENDING', true);

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            let response = await httpAPI({
                url: `/api/csc/calendarreceptionlist?filter=${await dispatch('getFilterObject')}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            console.log(response);

            let events = [];

            if (response?.data?.Payload) {
                response.data.Payload.forEach(item => {                    

                    const colors = ["#43B581", "#FAA61A", "#ff0000"];

                    events.push({ 
                        id: item.id, 
                        name: item.name, 
                        start: item.start, 
                        end: item.end, 
                        color: colors[item.status],
                        status: item.status,
                        recipient: item.recipient    
                    });
                });

                commit('SET_EVENTS', events);
            }

            commit('IS_PENDING', false);
        }
    },
    getters: {
        getCurrentPeriod: (s) => s.currentPeriod,
        getStartDate: (s) => s.startDate,
        getEndDate: (s) => s.endDate,
        getIsPending: (s) => s.isPending,
        getEvents: (s) => s.events
    }
}